export default defineNuxtPlugin(async () => {
  const loadAndCacheImage = async () => {
    const cache = await caches.open('frame-cache-v1');
    const frameUrl = `/frames/new/00000.webp`;

    // Если уже в кэше — не грузим
    const cached = await cache.match(frameUrl);
    if (cached) return;

    try {
      const response = await fetch(frameUrl, { mode: 'no-cors' });
      if (response.ok) await cache.put(frameUrl, response.clone());
    } catch (e) {
      console.warn('Image load error:', e);
    }
  };

  loadAndCacheImage();
});